import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import appMain from "@/views/memberCenter/appMain.vue";
import {getToken} from "@/utils/auth";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      index: 1,
      title: '陵企通-首页'
    }
  },
  {
    path: '/loginRegister',
    name: 'loginRegister',
    component: () => import('../views/loginRegister.vue'),
    meta: {
      fullscreen: true,
      title: '陵企通-登录'
    }
  },
  {
    path: '/richText/:id',
    name: 'richText',
    component: () => import('../views/richText.vue'),
    meta: {
      title: '陵企通'
    }
  },
  {
    path: '/demandHall',
    name: 'demandHall',
    component: () => import('../views/demandHall/demandHall.vue'),
    meta: {
      index: 2,
      title: '陵企通-需求大厅'
    }
  },
  {
    path: '/demandHallDetails/:id',
    name: 'demandHallDetails',
    component: () => import('../views/demandHall/demandHallDetails.vue'),
    meta: {
      index: 2,
      title: '陵企通-需求详情'
    }
  },
  {
    path: '/policyCenter',
    name: 'policyCenter',
    component: () => import('../views/policyCenter/policyCenter.vue'),
    meta: {
      index: 4,
      title: '陵企通-政策中心'
    }
  },
  {
    path: '/policyCenterDetails/:id',
    name: 'policyCenterDetails',
    component: () => import('../views/policyCenter/policyCenterDetails.vue'),
    meta: {
      index: 4,
      title: '陵企通-政策详情'
    }
  },
  {
    path: '/addPolicy/:id',
    name: 'addPolicy',
    component: () => import('../views/policyCenter/addPolicy.vue'),
    meta: {
      index: 4,
      title: '陵企通-政策申报'
    }
  },
  {
    path: '/activityCenter',
    name: 'activityCenter',
    component: () => import('../views/activityCenter/activityCenter.vue'),
    meta: {
      index: 5,
      title: '陵企通-活动中心'
    }
  },
  {
    path: '/activityCenterDetails/:id',
    name: 'activityCenterDetails',
    component: () => import('../views/activityCenter/activityCenterDetails.vue'),
    meta: {
      index: 5,
      title: '陵企通-活动详情'
    }
  },
  {
    path: '/addActivity/:id',
    name: 'addActivity',
    component: () => import('../views/activityCenter/addActivity.vue'),
    meta: {
      index: 5,
      title: '陵企通-活动报名'
    }
  },
  {
    path: '/serviceTeam',
    name: 'serviceTeam',
    component: () => import('../views/serviceTeam/serviceTeam.vue'),
    meta: {
      index: 6,
      title: '陵企通-服务团队'
    }
  },
  {
    path: '/serviceTeamDetails',
    name: 'serviceTeamDetails',
    component: () => import('../views/serviceTeam/serviceTeamDetails.vue'),
    meta: {
      index: 6,
      title: '陵企通-服务官详情'
    }
  },
  {
    path: '/enterpriseLibrary',
    name: 'enterpriseLibrary',
    component: () => import('../views/enterpriseLibrary/enterpriseLibrary.vue'),
    meta: {
      index: 7,
      title: '陵企通-企业库'
    }
  },
  {
    path: '/financial',
    name: 'financial',
    component: () => import('../views/financial/financial.vue'),
    meta: {
      index: 8,
      title: '陵企通-金融赋能'
    }
  },
  {
    path: '/productList/:id/:id2',
    name: 'productList',
    component: () => import('../views/financial/productList.vue'),
    meta: {
      index: 8,
      title: '陵企通-银行产品'
    }
  },
  {
    path: '/productDetail/:id',
    name: 'productDetail',
    component: () => import('../views/financial/productDetail.vue'),
    meta: {
      index: 8,
      title: '陵企通-银行产品详情'
    }
  },
  {
    path: '/productDetail2/:id',
    name: 'productDetail2',
    component: () => import('../views/financial/productDetail2.vue'),
    meta: {
      index: 8,
      title: '陵企通-保险产品详情'
    }
  },
  {
    path: '/rentalService',
    name: 'rentalService',
    component: () => import('../views/rentalService/rentalService.vue'),
    meta: {
      index: 9,
      title: '陵企通-租房服务'
    }
  },
  {
    path: '/rentalServiceDetail/:id',
    name: 'rentalServiceDetail',
    component: () => import('../views/rentalService/rentalServiceDetail.vue'),
    meta: {
      index: 9,
      title: '陵企通-厂房详情'
    }
  },
  {
    path: '/talentSupply',
    name: 'talentSupply',
    component: () => import('../views/talentSupply/talentSupply.vue'),
    meta: {
      index: 10,
      title: '陵企通-人才供给'
    }
  },
  {
    path: '/talentList',
    name: 'talentList',
    component: () => import('../views/talentSupply/talentList.vue'),
    meta: {
      index: 10,
      title: '陵企通-人才列表'
    }
  },
  {
    path: '/talentSupplyDetail/:id',
    name: 'talentSupplyDetail',
    component: () => import('../views/talentSupply/talentSupplyDetail.vue'),
    meta: {
      index: 10,
      title: '陵企通-人才详情'
    }
  },
  {
    path: '/jobList',
    name: 'jobList',
    component: () => import('../views/talentSupply/jobList.vue'),
    meta: {
      index: 10,
      title: '陵企通-职位列表'
    }
  },
  {
    path: '/jobDetail/:id',
    name: 'jobDetail',
    component: () => import('../views/talentSupply/jobDetail.vue'),
    meta: {
      index: 10,
      title: '陵企通-职位详情'
    }
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: () => import('../views/newsCenter/newsCenter.vue'),
    meta: {
      index: 11,
      title: '陵企通-新闻中心'
    }
  },
  {
    path: '/newsCenterDetails/:id',
    name: 'newsCenterDetails',
    component: () => import('../views/newsCenter/newsCenterDetails.vue'),
    meta: {
      index: 11,
      title: '陵企通-新闻详情'
    }
  },
  {
    path: '/hzPort',
    name: 'hzPort',
    component: () => import('../views/hangzhouPort/index.vue'),
    meta: {
      index: 12,
      title: '陵企通-一站式贸易平台'
    }
  },
  {
    path: '/hzPortDetails/:id',
    name: 'hzPortDetails',
    component: () => import('../views/hangzhouPort/indexDetails.vue'),
    meta: {
      index: 12,
      title: '陵企通-采购单详情'
    }
  },
  {
    path: '/enterpriseWebsite/:id',
    name: 'enterpriseWebsite',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsite.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-首页'
    }
  },
  {
    path: '/enterpriseWebsiteIntroduction/:id',
    name: 'enterpriseWebsiteIntroduction',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteIntroduction.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-公司简介'
    }
  },
  {
    path: '/enterpriseWebsiteDemand/:id',
    name: 'enterpriseWebsiteDemand',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteDemand.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-供求信息'
    }
  },
  {
    path: '/enterpriseWebsiteDemandDetails/:id/:id2',
    name: 'enterpriseWebsiteDemandDetails',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteDemandDetails.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-供求详情'
    }
  },
  {
    path: '/enterpriseWebsiteProduct/:id',
    name: 'enterpriseWebsiteProduct',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteProduct.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-公司产品'
    }
  },
  {
    path: '/enterpriseWebsiteProductDetails/:id/:id2',
    name: 'enterpriseWebsiteProductDetails',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteProductDetails.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-公司产品'
    }
  },
  {
    path: '/enterpriseWebsiteHonor/:id',
    name: 'enterpriseWebsiteHonor',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteHonor.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-企业业绩'
    }
  },
  {
    path: '/enterpriseWebsiteContact/:id',
    name: 'enterpriseWebsiteContact',
    component: () => import('../views/enterpriseLibrary/enterpriseWebsiteContact.vue'),
    meta: {
      index: 7,
      fullscreen: true,
      title: '陵企通企业站-联系我们'
    }
  },
  {
    path: '/enterpriseLibraryDetails/:id',
    name: 'enterpriseLibraryDetails',
    component: () => import('../views/enterpriseLibrary/enterpriseLibraryDetails.vue'),
    meta: {
      index: 7,
      title: '陵企通-企业详情'
    }
  },
  {
    path: '/memberCenter',
    name: 'memberCenter',
    component: appMain,
    meta: {

    },
    children: [
      {
        path: '/userProfile',
        name: 'userProfile',
        component: () => import('../views/memberCenter/userProfile.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 1,
          title: '陵企通会员中心-公司信息',
          requiresAuth: true
        }
      },
      {
        path: '/releaseRequirements',
        name: 'releaseRequirements',
        component: () => import('../views/memberCenter/releaseRequirements.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 2,
          title: '陵企通会员中心-发布需求',
          requiresAuth: true
        }
      },
      {
        path: '/myRequest',
        name: 'myRequest',
        component: () => import('../views/memberCenter/myRequest.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 3,
          title: '陵企通会员中心-我的需求',
          requiresAuth: true
        }
      },
      {
        path: '/myRequestDetails/:id',
        name: 'myRequestDetails',
        component: () => import('../views/memberCenter/myRequestDetails.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 3,
          title: '陵企通会员中心-我的需求详情',
          requiresAuth: true
        }
      },
      {
        path: '/releaseAppeal',
        name: 'releaseAppeal',
        component: () => import('../views/memberCenter/releaseAppeal.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 6,
          title: '陵企通会员中心-发布诉求',
          requiresAuth: true
        }
      },
      {
        path: '/myAppeal',
        name: 'myAppeal',
        component: () => import('../views/memberCenter/myAppeal.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 7,
          title: '陵企通会员中心-我的诉求',
          requiresAuth: true
        }
      },
      {
        path: '/myAppealDetails',
        name: 'myAppealDetails',
        component: () => import('../views/memberCenter/myAppealDetails.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 7,
          title: '陵企通会员中心-我的诉求详情',
          requiresAuth: true
        }
      },
      {
        path: '/releaseDeclare/:id',
        name: 'releaseDeclare',
        component: () => import('../views/memberCenter/releaseDeclare.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 4,
          title: '陵企通会员中心-政策申报',
          requiresAuth: true
        }
      },
      {
        path: '/myDeclare',
        name: 'myDeclare',
        component: () => import('../views/memberCenter/myDeclare.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 4,
          title: '陵企通会员中心-我的政策',
          requiresAuth: true
        }
      },
      {
        path: '/myDeclareDetails/:id',
        name: 'myDeclareDetails',
        component: () => import('../views/memberCenter/myDeclareDetails.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 4,
          title: '陵企通会员中心-我的政策详情',
          requiresAuth: true
        }
      },
      {
        path: '/releaseActivity/:id',
        name: 'releaseActivity',
        component: () => import('../views/memberCenter/releaseActivity.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 5,
          title: '陵企通会员中心-活动报名',
          requiresAuth: true
        }
      },
      {
        path: '/myActivity',
        name: 'myActivity',
        component: () => import('../views/memberCenter/myActivity.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 5,
          title: '陵企通会员中心-我的活动',
          requiresAuth: true
        }
      },
      {
        path: '/myActivityDetails/:id',
        name: 'myActivityDetails',
        component: () => import('../views/memberCenter/myActivityDetails.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 5,
          title: '陵企通会员中心-我的活动详情',
          requiresAuth: true
        }
      },
      {
        path: '/myRentalService',
        name: 'myRentalService',
        component: () => import('../views/memberCenter/myRentalService.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 8,
          title: '陵企通会员中心-租房管理',
          requiresAuth: true
        }
      },
      {
        path: '/myBankProduct',
        name: 'myBankProduct',
        component: () => import('../views/memberCenter/myBankProduct.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 9,
          title: '陵企通会员中心-我的产品',
          requiresAuth: true
        }
      },
      {
        path: '/myInsuranceProduct',
        name: 'myInsuranceProduct',
        component: () => import('../views/memberCenter/myInsuranceProduct.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 10,
          title: '陵企通会员中心-我的产品',
          requiresAuth: true
        }
      },
      {
        path: '/myOffer',
        name: 'myOffer',
        component: () => import('../views/memberCenter/myOffer.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 11,
          title: '陵企通会员中心-我的报价',
          requiresAuth: true
        }
      },
      {
        path: '/myOfferDetails/:id',
        name: 'myOfferDetails',
        component: () => import('../views/memberCenter/myOfferDetails.vue'),
        meta: {
          fullscreen: true,
          memberCenterIndex: 11,
          title: '陵企通会员中心-我的报价详情',
          requiresAuth: true
        }
      },
    ]
  },
  {
    path: '/largeScreenIndex',
    name: 'largeScreenIndex',
    component: () => import('../views/largeScreen/index.vue'),
    meta: {
      index: 9,
      fullscreen: true,
      title: '陵企通-驾驶舱'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // 恢复之前的滚动位置
      return savedPosition;
    } else {
      // 滚动到顶部或其他位置
      return { x: 0, y: 0 };
    }
  }
})

export default router

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push
let routerReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  document.title = to.meta.title; // 使用路由元信息设置标题
  // 检查用户是否已登录
  const isAuthenticated = !!getToken(); // 假设我们通过userToken来判断登录状态
  if (to.matched.some(record => record.meta.requiresAuth)) { // 判断目标路由是否需要认证
    if (!isAuthenticated) {
      next({ path: '/loginRegister' }); // 如果未登录，重定向到登录页面
    } else {
      next(); // 如果已登录，正常进入目标路由
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});